import SystemMessage from "components/SystemMessage";
import { ErrorCircleColored } from "components/icons/generated";
import Link from "ds/components/Link";
import {
  isPreProductionEnvironment,
  isPreProductionFedRampEnvironment,
  isProductionFedRampEnvironment,
  isProductionUsEnvironment,
} from "utils/env";

const getSpaceliftSignupLink = () => {
  if (isProductionUsEnvironment()) {
    return "https://spacelift.io/free-trial-us";
  }
  if (isProductionFedRampEnvironment()) {
    return "https://spacelift.io/free-trial-fedramp";
  }
  if (isPreProductionEnvironment()) {
    return "https://spacelift.dev/free-trial";
  }
  if (isPreProductionFedRampEnvironment()) {
    return "https://spacelift.dev/free-trial-fedramp";
  }
  return "https://spacelift.io/free-trial";
};

const AccountNotFoundError = () => {
  return (
    <SystemMessage
      icon={ErrorCircleColored}
      title="Account not found"
      message={
        <>
          Looks like you don't have account yet.
          <br></br>
          You can <Link href={getSpaceliftSignupLink()}>create one</Link>
        </>
      }
    />
  );
};

export default AccountNotFoundError;
